import React, { useEffect, useState } from "react";
import { Row, Col, Alert } from "react-bootstrap";
import { listLeads, listQuotes, listBookings, getProfileCompletion } from "../services/partnerAuthService";

export default function Overview() {
  const [stats, setStats] = useState({ leads: 0, quotes: 0, bookings: 0 });
  const [completion, setCompletion] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([listLeads(), listQuotes(), listBookings(), getProfileCompletion()])
      .then(([leadsRes, quotesRes, bookingsRes, completionRes]) => {
        setStats({
          leads: leadsRes.data.data?.length || 0,
          quotes: quotesRes.data.data?.length || 0,
          bookings: bookingsRes.data.data?.length || 0,
        });
        setCompletion(completionRes.data.data);
      })
      .catch(() => setError("Some dashboard data could not be loaded. Pull to refresh or try again shortly."));
  }, []);

  return (
    <div>
      <h4 className="mb-3">Dashboard</h4>
      {error && <Alert variant="warning">{error}</Alert>}

      {completion && completion.percent < 100 && (
        <Alert variant="info">
          Your profile is {completion.percent}% complete.{" "}
          {!completion.sections?.verification && "Add GST/PAN documents to speed up verification."}
        </Alert>
      )}

      <Row className="g-3">
        <Col md={4}>
          <div className="partner-stat-card">
            <div className="partner-stat-value">{stats.leads}</div>
            <div className="partner-stat-label">New Requests</div>
          </div>
        </Col>
        <Col md={4}>
          <div className="partner-stat-card">
            <div className="partner-stat-value">{stats.quotes}</div>
            <div className="partner-stat-label">Quotes Submitted</div>
          </div>
        </Col>
        <Col md={4}>
          <div className="partner-stat-card">
            <div className="partner-stat-value">{stats.bookings}</div>
            <div className="partner-stat-label">Bookings</div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
